import notification from './plugins/notification';

try {
    notification.init();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (error) {
    // Ideally, report this error to Sentry or another error tracking service
}
